import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
  getAllUserChats () {
    return client().get('appointments/Chats')
  },
  getChat (appointmentId, pastChat = false) {
    return client().get('appointments/Chats/GetAllChatMessages', { params: {appointmentId: appointmentId, pastChat: pastChat} })
  },
  getPastChat (appointmentId) {
    return client().get('appointments/Chats/GetChatById', { params: {appointmentId: appointmentId} })
  },
  sendMessage (appointmentId, msg, receiverId, file) {
    var chatMessage = {
      AppointmentId: appointmentId,
      Text: msg,
      ReceiverId: receiverId,
      File: file
    }
    return client().post('appointments/Chats/PostChatMessage', chatMessage)
  },
  deleteMessage (messageId){
    return client().delete('appointments/Chats/DeleteChatMessage', { params: {chatId: messageId} })
  },
  getMessage (messageId){
    return client().get('appointments/Chats/GetChatMessage', { params: {chatId: messageId}, loading: false })
  },
  editMessage (messageId, editedMessage){
    return client().get('appointments/Chats/EditChatMessage', { params: {chatId: messageId, editedMessage: editedMessage} })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/ChatRepository.js